import request from '@/api/request'

// 添加费用申请
export function addCostApply(data) {
  return request({
    url: '/cost/apply',
    method: 'post',
    data
  })
}

// 获取费用申请列表
export function getCostList(params) {
  return request({
    url: '/cost/list',
    method: 'get',
    params
  })
}

// 获取费用申请详情
export function getCostDetail(id) {
  return request({
    url: `/cost/detail/${id}`,
    method: 'get'
  })
}

// 更新费用申请状态
export function updateCostStatus(data) {
  return request({
    url: '/cost/status',
    method: 'put',
    data
  })
}